import React from 'react';
import { FaWhatsapp } from 'react-icons/fa';

const WhatsAppFab = () => {
  const phoneNumber = '+12012572156'; // Replace with your phone number (with country code)
  const message = 'Hello, I would like to know more!'; // Optional preset message

  const whatsappLink = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;

  return (
    <a href={whatsappLink} target="_blank" rel="noopener noreferrer" className="whatsapp-fab">
        <FaWhatsapp size={24} />
    </a>
  );
};

export default WhatsAppFab;
